import React, { useState, useEffect } from 'react';
import { openDB } from 'idb';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import SubPageHeader from '../../components/SubPageHeader';
import '../../styles/Collections.scss';
import Loading from '../../components/Loading';
import SeeAll from '../../images/see-all.jpg'
import { toDataURL } from '../../utils/offline-image';

export default function AllCollections({subView, setSubView, isOffline, updatesWaiting}) {

    const [collections, setCollections] = useState([])
    const [isLoading, setIsLoading] = useState(true)
  
    const getCollections = async () => {
        let getCollections;
        const parentId = subView?.id ? subView.id : process.env.REACT_APP_TOP_LEVEL_ID;
        console.log('parentId', parentId)
        const getDB = await openDB(process.env.REACT_APP_INDB_NAME)
        if (isOffline) {
            const getCollectionsData = await getDB.getAllFromIndex('collections', 'parent_id', Number(parentId))
            getCollections = []
            for (let i=0; i < getCollectionsData.length; i++) {
                if (getCollectionsData[i].download) {
                    getCollections.push({
                        ...getCollectionsData[i],
                        image_data_url: await toDataURL(getCollectionsData[i].image_url)
                    })
                }
            }
            getCollections.sort((a,b) => a.sort_order - b.sort_order)
        }

        else {
            getCollections = await getDB.getAllFromIndex('collections', 'parent_id', Number(parentId))
            getCollections.sort((a,b) => a.sort_order - b.sort_order)
        }
            
        setCollections(getCollections)
        setIsLoading(false)
    }
  
    useEffect(() => {
     getCollections()
    }, []);

  return (
    <Box className='background-color-wrapper' style={{ backgroundColor: subView.view === "" ? process.env.REACT_APP_PRIMARY_BG : process.env.REACT_APP_SECONDARY_BG}}>
        {isLoading ?
            <Loading />
        :
            <Box className='app-sub-page collection'>
                <SubPageHeader title={'Collections'} subView={subView} setSubView={setSubView} updatesWaiting={updatesWaiting} />
                <Box className='collection-grid'>
                    <Grid container direction="row" className='collection-grid-container'>
                        {collections.length > 0 && collections[0].level === 0 &&
                            <Grid item key={'all'} className="collection-grid-item">
                                <Button className='collection-grid-btn' onClick={(e) => setSubView({view: 'products', id: collections[0].parent_id, name: `All Glasses`, allCollections: true, last: subView})}>
                                    <img className='collection-grid-image' src={process.env.REACT_APP_SEE_ALL_IMG ? process.env.REACT_APP_SEE_ALL_IMG : SeeAll} alt="See All" />
                                </Button>
                            </Grid>
                        }
                        {collections.length > 0 ?
                            collections.map((c) => {
                                let imgSrc = c.image_url
                                if (c.image_data_url) {
                                    imgSrc = c.image_data_url;
                                }

                                return (
                                    <Grid key={c.id} item className="collection-grid-item">
                                        <Button className='collection-grid-btn' onClick={(e) => setSubView({view: c.level === 0 ? 'products' : 'collection', id: c.id, name: c.name, last: subView})}>
                                            <img className='collection-grid-image' src={imgSrc} alt={c.name} />
                                        </Button>
                                    </Grid>
                                )
                            })
                        :
                            <p>No collections are assigned to this brand.</p>
                        }
                    </Grid>
                </Box>
            </Box>
        }
    </Box>
  )
}
